import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import HomePage from './pages/HomePage';
import TheAssessmentPage from './pages/TheAssessmentPage';
import WhatYouDiscoverPage from './pages/WhatYouDiscoverPage';
import AboutPage from './pages/AboutPage';
import ForAdvisorsPage from './pages/ForAdvisorsPage';
import EvaluationPage from './pages/EvaluationPage';
import OnboardingPage from './pages/OnboardingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import Header from './components/common/Header';
import Footer from './components/common/Footer';
import { BookingProvider } from './components/common/BookingModal';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <BookingProvider>
      <div className="min-h-screen bg-cream flex flex-col">
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: 'rgba(41, 37, 36, 0.92)',
              color: '#fff',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(255, 255, 255, 0.1)',
            },
            success: {
              duration: 3000,
              iconTheme: { primary: '#5E7D6F', secondary: '#fff' },
            },
            error: {
              duration: 5000,
              iconTheme: { primary: '#B54A4A', secondary: '#fff' },
            },
          }}
        />

        <Header />

        <main className="flex-grow pt-20 lg:pt-24">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/assessment" element={<TheAssessmentPage />} />
            <Route path="/what-you-discover" element={<WhatYouDiscoverPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/advisors" element={<ForAdvisorsPage />} />
            <Route path="/evaluation" element={<EvaluationPage />} />
            <Route path="/onboarding" element={<OnboardingPage />} />
            <Route path="/privacy" element={<PrivacyPolicyPage />} />
            <Route path="/terms" element={<TermsOfServicePage />} />

            <Route
              path="*"
              element={
                <div className="min-h-[60vh] flex items-center justify-center">
                  <div className="text-center">
                    <h1 className="font-serif text-5xl font-semibold text-secondary-800 mb-3">
                      404
                    </h1>
                    <p className="text-secondary-500 mb-8">
                      We couldn&rsquo;t find that page.
                    </p>
                    <a
                      href="/"
                      className="btn-primary inline-block"
                    >
                      Return Home
                    </a>
                  </div>
                </div>
              }
            />
          </Routes>
        </main>

        <Footer />
      </div>
      </BookingProvider>
    </Router>
  );
}

export default App;
